export default __webpack_public_path__ + "static/mob-img01-d5a4916ac80c460c9ea48118cb888fcb.png";